import React from 'react';
import { useIsMobile } from '../../../../utils/useIsMobile';
import './kpi.scss';
const Kpi = ({ kpi_data }) => {
  const { value, text, sub_text } = kpi_data || {};
  const isMobile = useIsMobile();
  return (
    <div className="kpiHeader tw-box-border ${isMobile ? ' tw-p-3' : ' tw-p-5'}tw-h-32 tw-p-5 tw-rounded tw-bg-white">
      <div className={`${isMobile ? 'tw-font-bold' : 'bigValue tw-mb-2'}`}>{value != undefined ? value : ''}</div>
      <div className={`strongValue ${isMobile ? 'tw-mb-1' : ' tw-mb-2'}`}>
        {text ? text : 'Aucune donnée trouvé'}
      </div>
      <div className="lightValue">{sub_text ? sub_text : ''}</div>
    </div>
  );
};

export default React.memo(Kpi);
